var _circle, _g, _g2, _circle2, _g3, _circle3, _circle4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.9,
    fill: "white",
    fillOpacity: 0.07,
    stroke: "url(#paint0_radial_0_160)",
    strokeWidth: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_160)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.9,
    stroke: "url(#paint1_radial_0_160)",
    strokeWidth: 0.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0006 27.3035C30.6901 27.3035 32.8704 25.1232 32.8704 22.4337C32.8704 19.7442 30.6901 17.564 28.0006 17.564C25.3111 17.564 23.1309 19.7442 23.1309 22.4337C23.1309 25.1232 25.3111 27.3035 28.0006 27.3035Z",
    fill: "url(#paint2_linear_0_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9995 34.2604C29.5364 34.2604 30.7822 33.0145 30.7822 31.4777C30.7822 29.9408 29.5364 28.6949 27.9995 28.6949C26.4627 28.6949 25.2168 29.9408 25.2168 31.4777C25.2168 33.0145 26.4627 34.2604 27.9995 34.2604Z",
    fill: "url(#paint3_linear_0_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9995 43.9999C29.5364 43.9999 30.7822 42.754 30.7822 41.2172C30.7822 39.6803 29.5364 38.4344 27.9995 38.4344C26.4627 38.4344 25.2168 39.6803 25.2168 41.2172C25.2168 42.754 26.4627 43.9999 27.9995 43.9999Z",
    fill: "url(#paint4_linear_0_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3472 41.9129C21.884 41.9129 23.1299 40.667 23.1299 39.1301C23.1299 37.5933 21.884 36.3474 20.3472 36.3474C18.8103 36.3474 17.5645 37.5933 17.5645 39.1301C17.5645 40.667 18.8103 41.9129 20.3472 41.9129Z",
    fill: "url(#paint5_linear_0_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6519 41.9129C37.1887 41.9129 38.4346 40.667 38.4346 39.1301C38.4346 37.5933 37.1887 36.3474 35.6519 36.3474C34.115 36.3474 32.8691 37.5933 32.8691 39.1301C32.8691 40.667 34.115 41.9129 35.6519 41.9129Z",
    fill: "url(#paint6_linear_0_160)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_0_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8173 30.0863C34.6792 30.0863 34.5441 30.0451 34.4295 29.968C34.3148 29.891 34.2256 29.7815 34.1734 29.6536C34.1212 29.5257 34.1082 29.3851 34.1361 29.2498C34.1641 29.1145 34.2317 28.9906 34.3304 28.8939C35.6132 27.6364 36.4926 26.0253 36.8562 24.2661C37.2199 22.5069 37.0514 20.6793 36.3723 19.0162C35.6931 17.3531 34.5341 15.9299 33.0429 14.9282C31.5518 13.9264 29.7961 13.3914 27.9997 13.3914C26.2033 13.3914 24.4475 13.9264 22.9564 14.9282C21.4652 15.9299 20.3062 17.3531 19.627 19.0162C18.9479 20.6793 18.7794 22.5069 19.1431 24.2661C19.5067 26.0253 20.3861 27.6364 21.669 28.8939C21.7357 28.9575 21.7892 29.0337 21.8262 29.1181C21.8632 29.2026 21.8831 29.2935 21.8847 29.3857C21.8862 29.4779 21.8695 29.5694 21.8353 29.6551C21.8012 29.7407 21.7504 29.8187 21.6859 29.8846C21.6213 29.9504 21.5443 30.0028 21.4594 30.0386C21.3744 30.0744 21.2832 30.093 21.191 30.0932C21.0988 30.0935 21.0075 30.0754 20.9223 30.0401C20.8372 30.0047 20.7599 29.9528 20.695 29.8873C19.2148 28.4364 18.2001 26.5775 17.7805 24.5476C17.3609 22.5177 17.5553 20.4089 18.3389 18.49C19.1226 16.571 20.4599 14.9289 22.1805 13.773C23.9011 12.6172 25.9269 11.9999 27.9997 11.9999C30.0724 11.9999 32.0983 12.6172 33.8188 13.773C35.5394 14.9289 36.8767 16.571 37.6604 18.49C38.444 20.4089 38.6384 22.5177 38.2188 24.5476C37.7992 26.5775 36.7846 28.4364 35.3043 29.8873C35.1743 30.0148 34.9994 30.0862 34.8173 30.0863Z",
    fill: "url(#paint7_linear_0_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5655 29.0025L21.564 29.001C20.2598 27.7227 19.3659 26.0849 18.9962 24.2965C18.6265 22.5081 18.7978 20.6501 19.4882 18.9595C20.1786 17.2688 21.3569 15.8221 22.8727 14.8037C24.3886 13.7853 26.1735 13.2414 27.9997 13.2414C29.8259 13.2414 31.6107 13.7853 33.1266 14.8037C34.6425 15.8221 35.8207 17.2688 36.5112 18.9595C37.2016 20.6501 37.3728 22.5081 37.0031 24.2965C36.6334 26.0849 35.7395 27.7227 34.4354 29.001M21.5655 29.0025L34.8173 29.9363C34.7089 29.9362 34.6031 29.904 34.5131 29.8435C34.4231 29.7831 34.3532 29.6972 34.3123 29.5969C34.2713 29.4966 34.2611 29.3863 34.283 29.2802C34.305 29.1741 34.358 29.0769 34.4354 29.001M21.5655 29.0025C21.6179 29.0524 21.6598 29.1122 21.6888 29.1784C21.7179 29.2446 21.7335 29.3159 21.7347 29.3882C21.7359 29.4606 21.7228 29.5324 21.696 29.5996C21.6692 29.6667 21.6294 29.7279 21.5787 29.7796C21.5281 29.8312 21.4677 29.8723 21.4011 29.9004C21.3345 29.9285 21.2629 29.943 21.1906 29.9432C21.1183 29.9434 21.0466 29.9292 20.9799 29.9015C20.9131 29.8738 20.8525 29.8331 20.8015 29.7817L20.8 29.7802C19.341 28.3501 18.341 26.5179 17.9274 24.5172C17.5138 22.5165 17.7054 20.438 18.4778 18.5467C19.2502 16.6553 20.5683 15.0368 22.2641 13.8976C23.96 12.7583 25.9567 12.1499 27.9997 12.1499C30.0426 12.1499 32.0393 12.7583 33.7352 13.8976C35.431 15.0368 36.7491 16.6553 37.5215 18.5467C38.2939 20.438 38.4855 22.5165 38.0719 24.5172C37.6583 26.5179 36.6583 28.3501 35.1993 29.7802L35.1993 29.7802C35.0973 29.8802 34.9602 29.9362 34.8174 29.9363L21.5655 29.0025ZM34.4354 29.001L34.3304 28.8939L34.4354 29.001C34.4354 29.001 34.4354 29.001 34.4354 29.001Z",
    stroke: "url(#paint8_linear_0_160)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_0_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 39.8258C27.8158 39.8258 27.6389 39.7525 27.5084 39.622C27.3779 39.4915 27.3046 39.3146 27.3046 39.1301V33.5646C27.3046 33.3801 27.3779 33.2032 27.5084 33.0727C27.6389 32.9423 27.8158 32.869 28.0003 32.869C28.1848 32.869 28.3618 32.9423 28.4922 33.0727C28.6227 33.2032 28.696 33.3801 28.696 33.5646V39.1301C28.696 39.3146 28.6227 39.4915 28.4922 39.622C28.3618 39.7525 28.1848 39.8258 28.0003 39.8258Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 39.8258C27.8158 39.8258 27.6389 39.7525 27.5084 39.622C27.3779 39.4915 27.3046 39.3146 27.3046 39.1301V33.5646C27.3046 33.3801 27.3779 33.2032 27.5084 33.0727C27.6389 32.9423 27.8158 32.869 28.0003 32.869C28.1848 32.869 28.3618 32.9423 28.4922 33.0727C28.6227 33.2032 28.696 33.3801 28.696 33.5646V39.1301C28.696 39.3146 28.6227 39.4915 28.4922 39.622C28.3618 39.7525 28.1848 39.8258 28.0003 39.8258Z",
    fill: "url(#paint9_linear_0_160)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 39.6758C27.8556 39.6758 27.7168 39.6183 27.6145 39.5159C27.5121 39.4136 27.4546 39.2748 27.4546 39.1301V33.5646C27.4546 33.4199 27.5121 33.2811 27.6145 33.1788C27.7168 33.0764 27.8556 33.019 28.0003 33.019C28.145 33.019 28.2838 33.0764 28.3862 33.1788C28.4885 33.2811 28.546 33.4199 28.546 33.5646V39.1301C28.546 39.2748 28.4885 39.4136 28.3862 39.5159C28.2838 39.6183 28.145 39.6758 28.0003 39.6758Z",
    stroke: "url(#paint10_linear_0_160)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_0_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3479 37.7391C20.1633 37.7391 19.9864 37.6658 19.8559 37.5354C19.7255 37.4049 19.6522 37.228 19.6522 37.0435V34.2607C19.6515 34.1309 19.6871 34.0034 19.7551 33.8927C19.8231 33.7821 19.9207 33.6927 20.0369 33.6346L25.6023 30.8519C25.7675 30.7694 25.9586 30.7559 26.1337 30.8144C26.3088 30.8728 26.4535 30.9984 26.5359 31.1636C26.6184 31.3287 26.6319 31.5198 26.5735 31.6949C26.515 31.87 26.3894 32.0147 26.2243 32.0972L21.0435 34.6907V37.0435C21.0435 37.228 20.9702 37.4049 20.8398 37.5354C20.7093 37.6658 20.5324 37.7391 20.3479 37.7391Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3479 37.7391C20.1633 37.7391 19.9864 37.6658 19.8559 37.5354C19.7255 37.4049 19.6522 37.228 19.6522 37.0435V34.2607C19.6515 34.1309 19.6871 34.0034 19.7551 33.8927C19.8231 33.7821 19.9207 33.6927 20.0369 33.6346L25.6023 30.8519C25.7675 30.7694 25.9586 30.7559 26.1337 30.8144C26.3088 30.8728 26.4535 30.9984 26.5359 31.1636C26.6184 31.3287 26.6319 31.5198 26.5735 31.6949C26.515 31.87 26.3894 32.0147 26.2243 32.0972L21.0435 34.6907V37.0435C21.0435 37.228 20.9702 37.4049 20.8398 37.5354C20.7093 37.6658 20.5324 37.7391 20.3479 37.7391Z",
    fill: "url(#paint11_linear_0_160)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8022 34.2607L19.8022 34.2599C19.8016 34.158 19.8296 34.0581 19.8829 33.9713C19.9362 33.8845 20.0128 33.8143 20.1039 33.7688L20.104 33.7688L25.6693 30.9861C25.6694 30.9861 25.6694 30.9861 25.6694 30.9861C25.7989 30.9214 25.9488 30.9108 26.0862 30.9567C26.2235 31.0025 26.337 31.101 26.4017 31.2306C26.4664 31.3601 26.477 31.5101 26.4312 31.6474C26.3853 31.7848 26.2868 31.8983 26.1572 31.963L26.1571 31.963L20.9764 34.5565L20.8935 34.598V34.6907V37.0435C20.8935 37.1882 20.836 37.327 20.7337 37.4293C20.6314 37.5316 20.4926 37.5891 20.3479 37.5891C20.2031 37.5891 20.0643 37.5316 19.962 37.4293C19.8597 37.327 19.8022 37.1882 19.8022 37.0435L19.8022 34.2607Z",
    stroke: "url(#paint12_linear_0_160)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_0_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.654 37.739C35.4695 37.739 35.2925 37.6657 35.1621 37.5353C35.0316 37.4048 34.9583 37.2278 34.9583 37.0433V34.6905L29.7776 32.104C29.6124 32.0215 29.4868 31.8768 29.4284 31.7018C29.3699 31.5267 29.3834 31.3355 29.4659 31.1704C29.5484 31.0053 29.6931 30.8797 29.8682 30.8212C30.0433 30.7628 30.2344 30.7763 30.3995 30.8587L35.965 33.6415C36.0801 33.699 36.177 33.7873 36.2449 33.8966C36.3128 34.0059 36.3491 34.1319 36.3497 34.2606V37.0433C36.3497 37.2278 36.2764 37.4048 36.1459 37.5353C36.0154 37.6657 35.8385 37.739 35.654 37.739Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.654 37.739C35.4695 37.739 35.2925 37.6657 35.1621 37.5353C35.0316 37.4048 34.9583 37.2278 34.9583 37.0433V34.6905L29.7776 32.104C29.6124 32.0215 29.4868 31.8768 29.4284 31.7018C29.3699 31.5267 29.3834 31.3355 29.4659 31.1704C29.5484 31.0053 29.6931 30.8797 29.8682 30.8212C30.0433 30.7628 30.2344 30.7763 30.3995 30.8587L35.965 33.6415C36.0801 33.699 36.177 33.7873 36.2449 33.8966C36.3128 34.0059 36.3491 34.1319 36.3497 34.2606V37.0433C36.3497 37.2278 36.2764 37.4048 36.1459 37.5353C36.0154 37.6657 35.8385 37.739 35.654 37.739Z",
    fill: "url(#paint13_linear_0_160)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1083 34.6905V34.5978L35.0253 34.5563L29.8446 31.9698C29.8446 31.9698 29.8446 31.9698 29.8446 31.9698C29.715 31.9051 29.6165 31.7916 29.5707 31.6543C29.5248 31.5169 29.5354 31.367 29.6001 31.2374C29.6648 31.1079 29.7783 31.0093 29.9157 30.9635C30.053 30.9177 30.2029 30.9282 30.3324 30.9929C30.3325 30.9929 30.3325 30.9929 30.3325 30.9929L35.8979 33.7756L35.8979 33.7756C35.9882 33.8208 36.0642 33.89 36.1175 33.9758C36.1707 34.0614 36.1992 34.1602 36.1997 34.261V37.0433C36.1997 37.1881 36.1422 37.3269 36.0398 37.4292C35.9375 37.5315 35.7987 37.589 35.654 37.589C35.5093 37.589 35.3705 37.5315 35.2681 37.4292C35.1658 37.3269 35.1083 37.1881 35.1083 37.0433V34.6905Z",
    stroke: "url(#paint14_linear_0_160)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 35,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 17.4,
    fill: "url(#paint15_linear_0_160)",
    stroke: "url(#paint16_radial_0_160)",
    strokeWidth: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_160)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_0_160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 9,
    fill: "url(#paint17_linear_0_160)",
    fillOpacity: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 8.9,
    stroke: "url(#paint18_radial_0_160)",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 35,
    height: 35
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 17.5,
    fill: "url(#paint19_linear_0_160)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 17.4,
    stroke: "url(#paint20_radial_0_160)",
    strokeOpacity: 0.76,
    strokeWidth: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_160)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_0_160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 9,
    fill: "url(#paint21_linear_0_160)",
    fillOpacity: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 8.9,
    stroke: "url(#paint22_radial_0_160)",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_160",
    x: -10,
    y: -10,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_160",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_0_160",
    x: 11.5645,
    y: 5.99988,
    width: 32.8704,
    height: 30.0933,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_0_160",
    x: 21.3046,
    y: 26.869,
    width: 13.3914,
    height: 18.9568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_0_160",
    x: 13.6522,
    y: 24.7786,
    width: 18.9571,
    height: 18.9606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_0_160",
    x: 23.3926,
    y: 24.7854,
    width: 18.9571,
    height: 18.9536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_0_160",
    x: 10.2,
    y: 10.2,
    width: 45.6,
    height: 45.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.9,
    result: "effect1_foregroundBlur_0_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_0_160",
    x: 4.5,
    y: 0.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.25,
    result: "effect1_foregroundBlur_0_160"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.503706 1.66611) rotate(44.0741) scale(76.0495 121.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.503706 1.66611) rotate(44.0741) scale(76.0495 121.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_160",
    x1: 23.1309,
    y1: 17.564,
    x2: 34.6037,
    y2: 20.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_160",
    x1: 25.2168,
    y1: 28.6949,
    x2: 31.7727,
    y2: 30.3596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_160",
    x1: 25.2168,
    y1: 38.4344,
    x2: 31.7727,
    y2: 40.0991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_160",
    x1: 17.5645,
    y1: 36.3474,
    x2: 24.1204,
    y2: 38.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_160",
    x1: 32.8691,
    y1: 36.3474,
    x2: 39.4251,
    y2: 38.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_160",
    x1: 17.5645,
    y1: 21.0466,
    x2: 38.4349,
    y2: 21.0466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_160",
    x1: 18.2167,
    y1: 12.8223,
    x2: 38.4349,
    y2: 12.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_160",
    x1: 27.3046,
    y1: 32.869,
    x2: 29.0448,
    y2: 32.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_160",
    x1: 27.3481,
    y1: 33.1852,
    x2: 28.696,
    y2: 33.1852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_160",
    x1: 19.6522,
    y1: 30.7786,
    x2: 27.8479,
    y2: 32.8586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_160",
    x1: 19.8696,
    y1: 31.095,
    x2: 26.6093,
    y2: 31.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_160",
    x1: 29.3926,
    y1: 30.7854,
    x2: 37.5873,
    y2: 32.8672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_160",
    x1: 29.61,
    y1: 31.1015,
    x2: 36.3497,
    y2: 31.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_160",
    x1: 17,
    y1: 34.5,
    x2: 52,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_0_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3148 18.0413) rotate(44.0741) scale(47.5309 76.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_160",
    x1: 24,
    y1: 33,
    x2: 42,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4364F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FB1FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_0_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1619 24.5355) rotate(44.0741) scale(24.4445 39.0955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_160",
    x1: 6,
    y1: 21.5,
    x2: 41,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_0_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.31482 5.04132) rotate(44.0741) scale(47.5309 76.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_0_160",
    x1: 19,
    y1: 24,
    x2: 37,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56B4D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_0_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1619 15.5355) rotate(44.0741) scale(24.4445 39.0955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline2);
export default __webpack_public_path__ + "static/media/IconTimeline2.333277bb3bb8abf47342f445095cd815.svg";
export { ForwardRef as ReactComponent };